// Network page: live P2P status + connected peers, straight from GenosRTC. Drives
// home the showcase point — no server, peers sync directly over WebRTC.
import { html, esc } from "../ui/base.js";
import { subscribePeers, getPeerType, serverCount } from "../services/net.js";
import { GDB_NAME } from "../db/gdb.js";
import { mountMeshMonitor } from "../ui/mesh-monitor.js";

export default async () => {
  const el = document.createElement("main");
  el.className = "shell network-page";
  el.innerHTML = html`
    <h1 class="page-title">Network</h1>
    <p class="muted">dSocial runs entirely peer-to-peer over GenosRTC (WebRTC), self-organized as a <strong>cellular mesh</strong>: peers group into cells linked by bridge nodes. No server stores your data — every peer in the <code>${esc(GDB_NAME)}</code> room syncs directly.</p>

    <section class="settings-card">
      <h2>Mesh topology</h2>
      <div class="mesh-monitor" data-mesh></div>
      <ul class="mesh-legend">
        <li><i class="mesh-dot self"></i> You</li>
        <li><i class="mesh-dot peer"></i> Peer</li>
        <li><i class="mesh-dot bridge"></i> Bridge</li>
        <li><i class="mesh-dot server"></i> Server</li>
        <li><i class="mesh-dot cell"></i> Cell</li>
      </ul>
    </section>

    <section class="settings-card">
      <div class="net-status" data-status></div>
      <h2>Connected peers <span class="muted small" data-count>0</span></h2>
      <ul class="peer-list" data-peers></ul>
    </section>`;

  const statusBox = el.querySelector("[data-status]");
  const countBox = el.querySelector("[data-count]");
  const peersBox = el.querySelector("[data-peers]");
  const meshBox = el.querySelector("[data-mesh]");

  const unsub = subscribePeers((peers) => {
    const srv = serverCount();
    countBox.textContent = peers.length;
    statusBox.innerHTML = `<span class="net-dot ${peers.length ? "on" : "off"}"></span>${
      peers.length ? `Connected to ${peers.length} peer${peers.length > 1 ? "s" : ""}` : "Waiting for peers…"
    }${srv ? ` · ${srv} always-on node${srv > 1 ? "s" : ""}` : ""}`;
    peersBox.innerHTML = peers.length
      ? peers.map((p) => `<li class="mono">${esc(String(p).slice(0, 20))}…${getPeerType(p) === "superpeer" ? ` <span class="muted small">srv</span>` : ""}</li>`).join("")
      : `<li class="muted small">No peers yet — open dSocial in another browser or tab to see live sync.</li>`;
  });

  const stopMesh = mountMeshMonitor(meshBox);

  el._cleanup = () => { unsub?.(); stopMesh?.(); };
  return el;
};
